import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "bg_white m-20",
  style: {
    "margin-bottom": "70px"
  }
};
const _hoisted_2 = {
  class: "wrap text-black p-t-20 p-b-20 p-l-40 p-r-40"
};
const _hoisted_3 = {
  class: "basic_info"
};
const _hoisted_4 = {
  class: "others"
};
const _hoisted_5 = {
  class: "bg_white m-t-10 p-l-20 p-r-20 p-t-10 p-b-10 text-black footer",
  style: {
    "width": "100%"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_form = _resolveComponent("el-form");
  return _openBlock(), _createElementBlock("main", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form, {
    ref: "form",
    model: $data.form,
    rules: $data.rules,
    "label-width": "120px",
    class: "m-t-20",
    "label-position": "left"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_cache[9] || (_cache[9] = _createElementVNode("h3", null, "基础信息", -1)), _createVNode(_component_el_row, {
      gutter: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "编码",
          prop: "",
          required: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.id = $event),
            style: {
              "width": "60%"
            },
            disabled: "true",
            placeholder: ""
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "版权类型",
          prop: "copyright_type_id"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: $data.form.copyright_type_id,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.copyright_type_id = $event),
            placeholder: "请选择版权类型",
            disabled: "true",
            onChange: $options.changeCopyrightType
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.copyrightType, (item, index) => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: index,
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "onChange"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      gutter: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "名称",
          prop: "name"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.name,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form.name = $event),
            style: {
              "width": "60%"
            },
            placeholder: "请输入名称"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "紧急程度",
          prop: "urgency_degree"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: $data.form.urgency_degree,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.form.urgency_degree = $event),
            placeholder: "请选择紧急程度",
            onChange: $options.changeUrgencyDegree
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.urgencyDegree, (item, index) => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: index,
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "onChange"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })]), _createElementVNode("div", _hoisted_4, [_cache[27] || (_cache[27] = _createElementVNode("h3", null, "附件上传", -1)), $data.type_id == 1 ? (_openBlock(), _createBlock(_component_el_row, {
      key: 0
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "申请表",
          prop: "",
          required: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_upload, {
            class: "upload-demo",
            action: $options.api_upload_url,
            "with-credentials": true,
            "on-success": $options.handleSuccess,
            "on-preview": _ctx.handlePreview,
            "on-remove": $options.handleRemove,
            "before-upload": $options.fileUpload,
            limit: 1,
            accept: ".pdf, .xlsx, .docx, .doc, .xls",
            "file-list": $data.fileList
          }, {
            tip: _withCtx(() => _cache[11] || (_cache[11] = [_createElementVNode("div", {
              class: "el-upload__tip"
            }, " 支持PDF、Word、Excel格式，限10M内 ", -1)])),
            default: _withCtx(() => [_createVNode(_component_el_button, {
              size: "small",
              type: "primary"
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("上传")])),
              _: 1,
              __: [10]
            })]),
            _: 1
          }, 8, ["action", "on-success", "on-preview", "on-remove", "before-upload", "file-list"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "源程序代码",
          prop: "",
          required: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_upload, {
            class: "upload-demo",
            action: $options.api_upload_url,
            "with-credentials": true,
            "on-success": $options.handleSuccess1,
            "on-preview": _ctx.handlePreview1,
            "on-remove": $options.handleRemove1,
            "before-upload": $options.fileUpload,
            limit: 1,
            "on-exceed": _ctx.handleExceed1,
            accept: ".pdf, .xlsx, .docx, .doc, .xls",
            "file-list": $data.fileList1
          }, {
            tip: _withCtx(() => _cache[13] || (_cache[13] = [_createElementVNode("div", {
              class: "el-upload__tip"
            }, " 支持PDF、Word、Excel格式，限10M内 ", -1)])),
            default: _withCtx(() => [_createVNode(_component_el_button, {
              size: "small",
              type: "primary"
            }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("上传")])),
              _: 1,
              __: [12]
            })]),
            _: 1
          }, 8, ["action", "on-success", "on-preview", "on-remove", "before-upload", "on-exceed", "file-list"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "说明书",
          prop: "",
          required: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_upload, {
            class: "upload-demo",
            action: $options.api_upload_url,
            "with-credentials": true,
            "on-success": $options.handleSuccess2,
            "on-preview": _ctx.handlePreview2,
            "on-remove": $options.handleRemove2,
            "before-upload": $options.fileUpload,
            limit: 1,
            "on-exceed": _ctx.handleExceed2,
            accept: ".pdf, .xlsx, .docx, .doc, .xls",
            "file-list": $data.fileList2
          }, {
            tip: _withCtx(() => _cache[15] || (_cache[15] = [_createElementVNode("div", {
              class: "el-upload__tip"
            }, " 支持PDF、Word、Excel格式，限10M内 ", -1)])),
            default: _withCtx(() => [_createVNode(_component_el_button, {
              size: "small",
              type: "primary"
            }, {
              default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("上传")])),
              _: 1,
              __: [14]
            })]),
            _: 1
          }, 8, ["action", "on-success", "on-preview", "on-remove", "before-upload", "on-exceed", "file-list"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })) : (_openBlock(), _createBlock(_component_el_row, {
      key: 1
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "作品说明书",
          prop: "",
          required: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_upload, {
            class: "upload-demo",
            action: $options.api_upload_url,
            "with-credentials": true,
            "on-success": $options.handleSuccess3,
            "on-preview": _ctx.handlePreview3,
            "on-remove": $options.handleRemove3,
            "before-upload": $options.fileUpload,
            limit: 1,
            "on-exceed": _ctx.handleExceed3,
            accept: ".pdf, .xlsx, .docx, .doc, .xls",
            "file-list": $data.fileList3
          }, {
            tip: _withCtx(() => _cache[17] || (_cache[17] = [_createElementVNode("div", {
              class: "el-upload__tip"
            }, " 支持PDF、Word、Excel格式，限10M内 ", -1)])),
            default: _withCtx(() => [_createVNode(_component_el_button, {
              size: "small",
              type: "primary"
            }, {
              default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("上传")])),
              _: 1,
              __: [16]
            })]),
            _: 1
          }, 8, ["action", "on-success", "on-preview", "on-remove", "before-upload", "on-exceed", "file-list"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "法人作品声明",
          prop: "",
          required: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_upload, {
            class: "upload-demo",
            action: $options.api_upload_url,
            "with-credentials": true,
            "on-success": $options.handleSuccess4,
            "on-preview": _ctx.handlePreview4,
            "on-remove": $options.handleRemove4,
            "before-upload": $options.fileUpload,
            limit: 1,
            "on-exceed": _ctx.handleExceed4,
            accept: ".pdf, .xlsx, .docx, .doc, .xls",
            "file-list": $data.fileList4
          }, {
            tip: _withCtx(() => _cache[19] || (_cache[19] = [_createElementVNode("div", {
              class: "el-upload__tip"
            }, " 支持PDF、Word、Excel格式，限10M内 ", -1)])),
            default: _withCtx(() => [_createVNode(_component_el_button, {
              size: "small",
              type: "primary"
            }, {
              default: _withCtx(() => _cache[18] || (_cache[18] = [_createTextVNode("上传")])),
              _: 1,
              __: [18]
            })]),
            _: 1
          }, 8, ["action", "on-success", "on-preview", "on-remove", "before-upload", "on-exceed", "file-list"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "作品等级申请表",
          prop: "",
          required: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_upload, {
            class: "upload-demo",
            action: $options.api_upload_url,
            "with-credentials": true,
            "on-success": $options.handleSuccess5,
            "on-preview": _ctx.handlePreview5,
            "on-remove": $options.handleRemove5,
            "before-upload": $options.fileUpload,
            limit: 1,
            "on-exceed": _ctx.handleExceed5,
            accept: ".pdf, .xlsx, .docx, .doc, .xls",
            "file-list": $data.fileList5
          }, {
            tip: _withCtx(() => _cache[21] || (_cache[21] = [_createElementVNode("div", {
              class: "el-upload__tip"
            }, " 支持PDF、Word、Excel格式，限10M内 ", -1)])),
            default: _withCtx(() => [_createVNode(_component_el_button, {
              size: "small",
              type: "primary"
            }, {
              default: _withCtx(() => _cache[20] || (_cache[20] = [_createTextVNode("上传")])),
              _: 1,
              __: [20]
            })]),
            _: 1
          }, 8, ["action", "on-success", "on-preview", "on-remove", "before-upload", "on-exceed", "file-list"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "作品登记委托书",
          prop: "",
          required: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_upload, {
            class: "upload-demo",
            action: $options.api_upload_url,
            "with-credentials": true,
            "on-success": $options.handleSuccess6,
            "on-preview": _ctx.handlePreview6,
            "on-remove": $options.handleRemove6,
            "before-upload": $options.fileUpload,
            limit: 1,
            "on-exceed": _ctx.handleExceed6,
            accept: ".pdf, .xlsx, .docx, .doc, .xls",
            "file-list": $data.fileList6
          }, {
            tip: _withCtx(() => _cache[23] || (_cache[23] = [_createElementVNode("div", {
              class: "el-upload__tip"
            }, " 支持PDF、Word、Excel格式，限10M内 ", -1)])),
            default: _withCtx(() => [_createVNode(_component_el_button, {
              size: "small",
              type: "primary"
            }, {
              default: _withCtx(() => _cache[22] || (_cache[22] = [_createTextVNode("上传")])),
              _: 1,
              __: [22]
            })]),
            _: 1
          }, 8, ["action", "on-success", "on-preview", "on-remove", "before-upload", "on-exceed", "file-list"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 16
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "作品样本",
          prop: "",
          required: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_upload, {
            class: "upload-demo",
            action: $options.api_upload_url,
            "with-credentials": true,
            "on-success": $options.handleSuccess7,
            "on-preview": _ctx.handlePreview7,
            "on-remove": $options.handleRemove7,
            "before-upload": $options.fileUpload,
            limit: 1,
            "on-exceed": _ctx.handleExceed7,
            accept: ".pdf, .xlsx, .docx, .doc, .xls",
            "file-list": $data.fileList7
          }, {
            tip: _withCtx(() => _cache[25] || (_cache[25] = [_createElementVNode("div", {
              class: "el-upload__tip"
            }, " 支持PDF、Word、Excel格式，限10M内 ", -1)])),
            default: _withCtx(() => [_createVNode(_component_el_button, {
              size: "small",
              type: "primary"
            }, {
              default: _withCtx(() => _cache[24] || (_cache[24] = [_createTextVNode("上传")])),
              _: 1,
              __: [24]
            })]),
            _: 1
          }, 8, ["action", "on-success", "on-preview", "on-remove", "before-upload", "on-exceed", "file-list"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })), _createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 24
      }, {
        default: _withCtx(() => [_cache[26] || (_cache[26] = _createElementVNode("h3", null, "申请结果", -1)), _createVNode(_component_el_radio_group, {
          modelValue: $data.form.apply_result,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.form.apply_result = $event),
          onChange: $options.changeApply
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.checkData, (item, index) => {
            return _openBlock(), _createBlock(_component_el_radio, {
              key: index,
              label: item.id
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
              _: 2
            }, 1032, ["label"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue", "onChange"])]),
        _: 1,
        __: [26]
      })]),
      _: 1
    }), _cache[28] || (_cache[28] = _createElementVNode("h3", null, "费用信息", -1)), _createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "单价",
          prop: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.price,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.form.price = $event),
            style: {
              "width": "60%"
            },
            placeholder: "仅限数字，支持小数",
            onChange: $options.changePrice
          }, null, 8, ["modelValue", "onChange"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "数量",
          prop: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.num,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.form.num = $event),
            style: {
              "width": "60%"
            },
            placeholder: "仅限正整数",
            onChange: $options.changeNum
          }, null, 8, ["modelValue", "onChange"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "总计",
          prop: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.total_price,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.form.total_price = $event),
            style: {
              "width": "60%"
            },
            placeholder: "",
            disabled: "true"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })])]),
    _: 1
  }, 8, ["model", "rules"])])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
    type: "primary",
    class: "search_button",
    onClick: _cache[8] || (_cache[8] = $event => $options.submitClick('form'))
  }, {
    default: _withCtx(() => _cache[29] || (_cache[29] = [_createTextVNode("提交")])),
    _: 1,
    __: [29]
  })])]);
}